export default __webpack_public_path__ + "static/media/cursor_click.ba92cc75.svg";